type EventCallback = (...args: any[]) => void

class EventEmitter {
  private events: { [key: string]: EventCallback[] } = {}

  on(event: string, callback: EventCallback) {
    if (!this.events[event])
      this.events[event] = []
    this.events[event].push(callback)
  }

  off(event: string, callback: EventCallback) {
    if (!this.events[event])
      return
    this.events[event] = this.events[event].filter(cb => cb !== callback)
  }

  emit(event: string, ...args: any[]) {
    if (!this.events[event])
      return
    this.events[event].forEach(callback => callback(...args))
  }
}

export const globalEventEmitter = new EventEmitter()
